<template>
  <v-list>
    <template v-for="(bot, bindex) in optionBotlist">
      <v-list-tile
        :id="`bot_${bot.value}`"
        class="page"
        :key="`bot_${bindex}`"
        :class="{primary: value == bot.value}"
        @click="selectPage(bot.value, bot.line_modular_botid)"
      >
        <div
          class="pa-2 img"
          :class="{ active: value == bot.value, islock: bot.isLock }"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-avatar v-on="on" size="30">
                <img
                  class="responsive-img circle"
                  style="min-width: 100%"
                  alt
                  @error="onError"
                  :src="
                    bot.pagelogo
                      ? bot.pagelogo
                      : 'https://graph.facebook.com/' +
                        bot.value +
                        '/picture?width=100&height=100&SameSite=None'
                  "
                />
              </v-avatar>

              {{ bot.name | truncate(25) }}
              <v-chip
                dark
                v-if="bot.isLock"
                v-on="on"
                color="amber"
                small
                class="elevation-0"
              >
                <v-icon small>lock</v-icon>
                <slot></slot>
              </v-chip>
            </template>
            <span>{{ bot.name }}</span>
          </v-tooltip>
        </div>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
import LivechatPagelist from './LivechatPagelist.js'

export default {
  mixins: [LivechatPagelist]
}
</script>

<style lang="scss" scoped>
.page {
  .img {
    cursor: pointer;
    &.active {
      cursor: default;
    }

    &.islock {
      filter: grayscale(100%);
      // cursor: not-allowed;
    }
  }
}
</style>

<style lang="scss">
.page .v-badge--overlap .v-badge__badge {
  top: 1px;
  right: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-pagelist-mobile.vue